export default __webpack_public_path__ + "static/media/indonesia.75279831.svg";